import { useContext } from 'react';

import CollapsibleContext, { CollapsibleValues } from './context';

const useCollapsible = (): CollapsibleValues => useContext(CollapsibleContext);

export default useCollapsible;
